import { Persona } from './persona';

import ImageAlex from './images/alex.jpg';
import ImageJade from './images/jade.jpg';
import ImageLola from './images/lola.jpg';
import ImageNoah from './images/noah.jpg';
import ImageRico from './images/rico.jpg';
import ImageTina from './images/tina.jpg';
import ImageVienna from './images/vienna.jpg';
import ImageGerard from './images/gerard.jpg';
import ImageMartin from './images/martin.jpg';
import ImageOlivia from './images/olivia.jpg';
import ImageNadia from './images/nadia.jpg';
import ImageLucas from './images/lucas.jpg';
import ImageSophie from './images/sophie.jpg';
import ImageThomas from './images/thomas.jpg'

const Personas: Persona[] = [
	{
		id: 'lola',
		name: 'Lola',
		age: 34,
		image: {
			src: ImageLola,
			alt: 'Lachend persoon met lange bruine haren en shirt met een wild patroon',
		},
		biography:
			"Lola houdt van gamen, televisie en radio. Ze kijkt iedere ochtend naar het nieuws en luistert graag naar muziek. Op haar zesentwintigste was er pas ontdekt dat ze kleurenblind is. Doordat veel televisieprogramma's geen rekening houden met haar kleurenblindheid, kan ze niet altijd alle informatie lezen of grafieken begrijpen. Bij online content mist ze vaak belangrijke informatie in infographics en datavisualisaties, vooral wanneer deze alleen op kleur vertrouwen om informatie over te brengen.",
		disabilities: [
			{
				category: 'visueel',
				value: 'kleurenblind',
				duration: 'permanent',
				description: 'tritanopie (blauw-geel kleurenblindheid)',
			},
		],
		details: [
			{
				id: 'hobby',
				value: "gamen, muziekprogramma's op televisie en radio",
			},
			{ id: 'morningRitual', value: 'het nieuws kijken' },
		],
		test: ['contrastChecker', 'colorIndependence'],
		tools: ['colorFilter'],
	},
	{
		id: 'alex',
		name: 'Alex',
		age: 21,
		image: {
			src: ImageAlex,
			alt: 'Persoon met bril op die in een stoel languit een boek leest.',
		},
		biography:
			'Alex is een student. Hij heeft een motorische beperking en kan niet lang staan of lopen. Wanneer hij veel pijn heeft gebruikt hij een rolstoel en een schermlezer met toetsenbordnavigatie. Hij volgt online colleges en moet vaak snel tussen verschillende digitale hulpmiddelen wisselen. Websites die hem dwingen om de muis te gebruiken of die ingewikkelde drag-and-drop functies hebben maken zijn studie onnodig moeilijk. Hij waardeert duidelijke sneltoetsen en een logische tabvolgorde.',
		disabilities: [
			{
				category: 'motorisch',
				value: 'spierziekte',
				duration: 'permanent',
				description: 'spierziekte',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'documentaires kijken en studeren',
			},
			{ id: 'study', value: 'informatica' },
		],
		test: ['focusOutline', 'keyboardNavigation'],
		tools: [
			'wheelchair',
			'screenReaderKeyboard',
			'screenReaderMobileSwipe',
		],
	},
	{
		id: 'rico',
		name: 'Rico',
		age: 31,
		image: {
			src: ImageRico,
			alt: 'Lachend persoon op een portretfoto met kort kroeshaar.',
		},
		biography:
			'Rico houdt van podcasts en tv. Door diens dyslexie heeft die moeite met lezen en schrijven. Ondertiteling is ook niet makkelijk om bij te houden, wanneer er iets in een andere taal wordt gezegd. Rico vindt spellingcheckers een uitkomst, maar zou graag tekst-naar-spraak opties hebben voor langere artikelen. Media met veel tekst en weinig visuele ondersteuning zorgen voor een minder prettige ervaring.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'dyslexie',
				duration: 'permanent',
				description: 'dyslexie',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'podcasts en tv kijken',
			},
			{
				id: 'morningRitual',
				value: 'de nieuwe aflevering van diens favoriete podcast luisteren',
			},
		],
		test: ['textParsable', 'ownPace'],
		tools: ['textToSpeech', 'spokenSubtitles'],
	},
	{
		id: 'noah',
		name: 'Noah',
		age: 8,
		image: {
			src: ImageNoah,
			alt: 'Persoon met lang rood haar op vakantie in een gebied met besneeuwde bergen.',
		},
		biography:
			'Noah is een fan van tekenfilms en games. Door zijn slechthorendheid heeft hij moeite met het verstaan van dialogen en muziek. Er is veel informatie die hij mist, omdat het niet altijd visueel duidelijk is. Noah is gebarentaal aan het leren, omdat zijn gehoor steeds minder wordt. Voor hem zijn kinderprogramma\'s zonder ondertiteling of met te snelle ondertiteling een grote uitdaging.',
		disabilities: [
			{
				category: 'auditief',
				value: 'slechthorend',
				duration: 'permanent',
				description: 'slechthorendheid',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'tekenfilms en games',
			},
		],
		test: ['noSound', 'captions'],
		tools: ['captions', 'signLanguage'],
	},
	{
		id: 'jade',
		name: 'Jade',
		age: 25,
		image: {
			src: ImageJade,
			alt: 'Persoon kijkt blij naar een kopje koffie.',
		},
		biography:
			'Jade houdt van muziek en films. Door haar autisme heeft ze moeite met het filteren van prikkels. Jade heeft een vast ritme en houdt van voorspelbaarheid. Ze gebruikt haar scherm met lage helderheid en heeft animaties uitgezet in haar systeeminstellingen. Ze ervaart overprikkeling bij websites of programma\'s met veel bewegende elementen, felle kleuren of onverwachte geluiden. Ze waardeert content met een rustige layout en duidelijke structuur.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'autisme',
				duration: 'permanent',
				description: 'autisme',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'muziek en films',
			},
			{
				id: 'morningRitual',
				value: 'de dag beginnen met muziek',
			},
		],
		test: ['contrastChecker', 'noAnimations', 'ownPace'],
		tools: ['noAnimations'],
	},
	{
		id: 'vienna',
		name: 'Vienna',
		age: 42,
		image: {
			src: ImageVienna,
			alt: 'Persoon met strakke make-up en twee oorbellen kijkt om naar de camera.',
		},
		biography:
			'Vienna houdt van lezen en muziek. Door haar tinnitus heeft ze moeite met het verstaan van dialogen en muziek. Ze gebruikt ondertiteling voor doven en slechthorenden om alle informatie mee te krijgen. Alleen bestaat ondertiteling vaak nog alleen uit letterlijke gesproken tekst en zijn sprekers onduidelijk, vooral op sociale media. Bij documentaires mist ze vaak belangrijke audio-informatie zoals muziek of omgevingsgeluiden die niet worden vertaald naar ondertitels.',
		disabilities: [
			{
				category: 'auditief',
				value: 'tinnitus',
				duration: 'permanent',
				description: 'tinnitus (oorsuizen)',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'lezen en muziek',
			},
			{
				id: 'morningRitual',
				value: 'de dag beginnen met een hoofdstuk uit een boek',
			},
		],
		test: ['noSound', 'captions'],
		tools: ['captions'],
	},
	{
		id: 'gerard',
		name: 'Gerard',
		age: 73,
		image: {
			src: ImageGerard,
			alt: 'Oudere man met grijs haar en leesbril',
		},
		biography:
			'Gerard is een gepensioneerde leraar die graag actualiteitenprogramma\'s kijkt en de digitale krant leest. Door zijn leeftijd heeft hij meerdere beperkingen: verminderd zicht, lichte tremor in zijn handen en gehoorverlies. Hij gebruikt een tablet met vergrotingsfunctie en heeft moeite met kleine knoppen en tekst. Websites of apps die niet geschaald kunnen worden of kleine bedieningselementen hebben zijn voor hem frustrerend. Hij is technisch vaardig maar wordt belemmerd door interfaces die geen rekening houden met zijn fysieke beperkingen.',
		disabilities: [
			{
				category: 'visueel',
				value: 'slechtziend',
				duration: 'permanent',
				description: 'leeftijdsgerelateerde maculadegeneratie',
			},
			{
				category: 'auditief',
				value: 'slechthorend',
				duration: 'permanent',
				description: 'ouderdomsslechthorendheid',
			},
			{
				category: 'motorisch',
				value: 'parkinson',
				duration: 'permanent',
				description: 'lichte tremor in de handen',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'actualiteitenprogramma\'s kijken en digitale kranten lezen',
			},
			{
				id: 'morningRitual',
				value: 'koffie drinken terwijl hij het nieuws leest op zijn tablet',
			},
		],
		test: ['contrastChecker', 'focusOutline', 'keyboardNavigation', 'captions', 'ownPace'],
		tools: ['magnifier', 'captions'],
	},
	{
		id: 'tina',
		name: 'Tina',
		age: 19,
		image: {
			src: ImageTina,
			alt: 'Iemand met een zonnebril op poseert met een drankje voor de camera.',
		},
		biography:
			'Tina heeft een tijdelijke beperking. Ze heeft net een hersenschudding gehad en kan niet goed tegen felle lichten en harde geluiden. Ze gaat af en toe al naar buiten met een zonnebril op. De prikkels van het licht van schermen zijn nog te veel. Om toch te kunnen genieten van de dingen die ze altijd dagelijks deed en geen contacten te verliezen, gebruikt ze een schermlezer op haar telefoon met spraakbesturing. Nu kan ze alsnog alles doen, maar programma\'s zonder goede audio-alternatieven of spraaknavigatie zijn voor haar ontoegankelijk.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'hersenschudding',
				duration: 'tijdelijk',
				description: 'hersenschudding',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'naar buiten gaan en met vrienden afspreken',
			},
		],
		test: ['keyboardNavigation', 'ownPace'],
		tools: ['screenReaderMobileTouch', 'screenReaderMobileVoice'],
	},
	{
		id: 'olivia',
		name: 'Olivia',
		age: 28,
		image: {
			src: ImageOlivia,
			alt: 'Jonge vrouw met donker haar en zonnebril',
		},
		biography:
			'Olivia is volledig blind en werkt als juriste. Ze is een luisteraar van podcasts, audioboeken en radio-uitzendingen. Voor haar werk en privéleven gebruikt ze intensief een schermlezer. Ze frustreert zich over websites die geen goede alt-teksten hebben bij afbeeldingen, of complex opgemaakte tabellen die haar schermlezer niet goed kan interpreteren. Bij video content mist ze vaak essentiële visuele context wanneer er geen audiodescriptie aanwezig is. Content die alleen visuele informatie geeft zonder verbale beschrijving sluit haar volledig buiten.',
		disabilities: [
			{
				category: 'visueel',
				value: 'blind',
				duration: 'permanent',
				description: 'volledige blindheid sinds geboorte',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'podcasts luisteren en radio-uitzendingen volgen',
			},
			{
				id: 'study',
				value: 'rechten',
			},
		],
		test: ['audioDescriptionAndAltText', 'textParsable', 'keyboardNavigation'],
		tools: ['screenReaderKeyboard', 'screenReaderMobileTouch', 'textToSpeech'],
	},
	{
		id: 'martin',
		name: 'Martin',
		age: 45,
		image: {
			src: ImageMartin,
			alt: 'Man met hoed loopt in metrostation',
		},
		biography:
			'Martin is een forens die zijn dagelijkse nieuws en entertainment vooral onderweg consumeert. Hij is niet permanent beperkt, maar bevindt zich vaak in situaties waar hij bepaalde zintuigen beperkt kan gebruiken: in een luidruchtige metro kan hij audio slecht horen, in fel zonlicht kan hij zijn scherm slecht zien, en met handschoenen in de winter heeft hij beperkte touchscreen-functionaliteit. Hij waardeert media die rekening houdt met deze situationele beperkingen door ondertiteling, goed contrast en eenvoudige bedieningselementen aan te bieden.',
		disabilities: [
			{
				category: 'visueel',
				value: 'slechtziend',
				duration: 'situationeel',
				description: 'verminderd zicht door omgevingsfactoren',
			},
			{
				category: 'auditief',
				value: 'slechthorend',
				duration: 'situationeel',
				description: 'verminderd gehoor in luidruchtige omgevingen',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'nieuwsconsumptie en podcasts tijdens woon-werkverkeer',
			},
			{
				id: 'morningRitual',
				value: 'nieuws checken in de metro',
			},
		],
		test: ['noSound', 'captions', 'contrastChecker', 'keyboardNavigation'],
		tools: ['captions', 'textToSpeech'],
	},
	{
		id: 'nadia',
		name: 'Nadia',
		age: 36,
		image: {
			src: ImageNadia,
			alt: 'Vrouw met hoofddoek en bril',
		},
		biography:
			'Nadia is een nieuwkomer in Nederland die Nederlands als tweede taal leert. Ze heeft een vorm van dyscalculie, wat haar begrip van getallen en grafieken bemoeilijkt. Ze kijkt veel educatieve programma\'s om de taal te leren, maar heeft moeite wanneer er te snel wordt gesproken of wanneer er veel vakjargon wordt gebruikt. Ondertiteling helpt haar enorm, maar alleen als deze niet te snel verdwijnt en duidelijk leesbaar is. Ze gebruikt vaak de pauzeknop om de ondertiteling rustig te kunnen lezen.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'dyscalculie',
				duration: 'permanent',
				description: 'moeite met getallen en berekeningen',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'educatieve programma\'s en documentaires kijken',
			},
			{
				id: 'study',
				value: 'Nederlandse taal',
			},
		],
		test: ['ownPace', 'captions', 'textParsable'],
		tools: ['captions', 'textToSpeech'],
	},
	{
		id: 'lucas',
		name: 'Lucas',
		age: 10,
		image: {
			src: ImageLucas,
			alt: 'Jongen met kort haar en een speels t-shirt',
		},
		biography:
			'Lucas is een energieke jongen die dol is op games en YouTube-video\'s. Door zijn ADHD heeft hij moeite met concentratie en is hij snel afgeleid door bewegende elementen, felle kleuren of onverwachte geluiden. Educatieve programma\'s die lange stukken uitleg bevatten zonder interactie of visuele ondersteuning verliest hij snel zijn interesse in. Hij heeft behoefte aan heldere structuur, korte segmenten en interactieve elementen om zijn aandacht vast te houden. Zijn ouders zoeken bewust naar content die rekening houdt met zijn aandachtsspanne zonder dat het kinderachtig voelt voor zijn leeftijd.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'adhd',
				duration: 'permanent',
				description: 'aandachtstekortstoornis met hyperactiviteit',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'games spelen en YouTube-video\'s kijken',
			},
			{
				id: 'morningRitual',
				value: 'een snelle game spelen voordat hij naar school gaat',
			},
		],
		test: ['ownPace', 'noAnimations', 'keyboardNavigation', 'audioPauseControl'],
		tools: ['noAnimations'],
	},
	{
		id: 'sophie',
		name: 'Sophie',
		age: 7,
		image: {
			src: ImageSophie,
			alt: 'Meisje met lang haar en een kleurrijke jurk',
		},
		biography:
			'Sophie heeft CVI (Cerebrale Visuele Inperking), een vorm van slechtziendheid die wordt veroorzaakt door hersenbeschadiging. Ze kan zien, maar heeft moeite met het verwerken en interpreteren van visuele informatie. Complexe beelden, drukke achtergronden of snel bewegende beelden zijn moeilijk voor haar om te begrijpen. Sophie kijkt graag naar kinderprogramma\'s maar heeft baat bij content met duidelijke contrasten, eenvoudige beelden en een rustig tempo. Haar ouders kiezen programma\'s met een heldere vertelstructuur en goede verbale beschrijvingen van wat er gebeurt. Ze gebruikt soms een tablet met vergrotingsfunctie om details beter te kunnen zien.',
		disabilities: [
			{
				category: 'visueel',
				value: 'slechtziend',
				duration: 'permanent',
				description: 'CVI (Cerebrale Visuele Inperking)',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'kinderprogramma\'s kijken en luisteren naar voorleesverhalen',
			},
		],
		test: ['contrastChecker', 'ownPace', 'audioDescriptionAndAltText'],
		tools: ['magnifier', 'textToSpeech'],
	},
	{
		id: 'thomas',
		name: 'Thomas',
		age: 36,
		image: {
			src: ImageThomas,
			alt: 'Man van middelbare leeftijd met een vriendelijke glimlach',
		},
		biography:
			'Thomas werkte als accountant tot hij enkele jaren geleden een beroerte kreeg, wat resulteerde in geheugenproblemen. Hij kan nieuwe informatie moeilijk onthouden en raakt snel verward bij complexe interfaces of lange instructies. Thomas kijkt dagelijks naar het nieuws en documentaires, maar heeft moeite om lange verhaallijnen te volgen. Websites of programma\'s met tijdslimieten zijn voor hem frustrerend, omdat hij vaak langer tijd nodig heeft om informatie te verwerken. Hij waardeert interfaces die duidelijke navigatie bieden, contextuele herinneringen geven en waar hij informatie in zijn eigen tempo kan verwerken zonder dat er iets verloren gaat.',
		disabilities: [
			{
				category: 'neurologisch',
				value: 'geheugenverlies',
				duration: 'permanent',
				description: 'geheugenproblemen na een beroerte',
			},
		],
		details: [
			{
				id: 'hobby',
				value: 'documentaires kijken en tuinieren',
			},
			{
				id: 'morningRitual',
				value: 'rustig ontbijten terwijl hij het nieuws kijkt',
			},
		],
		test: ['ownPace', 'textParsable'],
		tools: ['textToSpeech'],
	},
];

export default Personas;
